import actions from "~/shared/actions";
import * as server from "~/shared/api/server";

export const loadSamtykkeTexts = () => (dispatch) => {
	dispatch(actions.samtykkeTextsRequest());
	return server.getSamtykkeTexts().then((texts) => dispatch(actions.samtykkeTextsResponse(texts)));
};
